<template>
    <div class="end-user-service-form">
        <b-overlay :show="isLoading" rounded="sm">
            <b-form @submit="onSubmit" @reset="onReset" v-if="form.show">
                <b-card title="Bilgilendirme" sub-title="Lütfen aşağıdaki açıklamayı dikkatlice okuyunuz.">
                    <b-card-text>
                        Servise gelen cihaz veya ürünlerin onarımı ve servis işlemleri sırasında cihazda kayıtlı kişisel bilgiler, telefon
                        rehberi, mesajlar, resimler, media uygulamaları, not defteri, ajanda ve her türlü sonradan yüklenen kayıtların
                        silinmesi mümkündür. Bu nedenle cihazların servis merkezimize gelmeden önce yedeklenmesi gerekmektedir.
                        Servis merkezimize gelen cihazlarla birlikte sim kart teslim alınmaz. Serviste bırakılan sim kartlarla ilgili firmamız
                        sorumluluk kabul etmez.
                    </b-card-text>

                    <b-card-text>

                        <b-form-group id="input-group-4">
                            <b-form-checkbox
                            id="checkbox-1"
                            v-model="form.accepted"
                            name="checkbox-1"
                            value="true"
                            unchecked-value="false"
                            required
                            >
                            Okudum, anladım ve kabul ediyorum.
                            </b-form-checkbox>
                        </b-form-group>
                    </b-card-text>
                </b-card>

                <b-card v-if="form.accepted == 'true'" class="mt-3" title="Kayıt Formu" sub-title="Lütfen formu eksiksiz ve doğru bilgiler ile doldurunuz.">
                    <b-form-group id="input-group-2" label="Ad Soyad:" label-for="input-1">
                        <b-form-input
                        id="input-1"
                        v-model="form.nameSurname"
                        placeholder="Adınızı ve soyadınızı girin."
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Adres:" label-for="input-2">
                        <b-form-input
                        id="input-2"
                        v-model="form.address1"
                        placeholder="Cadde ve sokak bilginizi girin."
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Adres (Devam):" label-for="input-3">
                        <b-form-input
                        id="input-3"
                        v-model="form.address2"
                        placeholder="Bina ve daire bilginizi girin."
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Adres (Devam):" label-for="input-4">
                        <b-form-input
                        id="input-4"
                        v-model="form.address3"
                        placeholder="Semt / ilçe bilginizi girin."
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-3" label="Şehir:" label-for="input-5">
                        <b-form-select
                        id="input-5"
                        v-model="form.city"
                        :options="cities"
                        required
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Telefon:" label-for="input-6">
                        <b-form-input
                        id="input-6"
                        v-model="form.telephone"
                        placeholder="Telefon numaranızı girin."
                        type="tel"
                        required
                        ></b-form-input>
                    </b-form-group>           

                    <b-form-group 
                        id="input-group-2" 
                        label="Email:" 
                        label-for="input-7"
                        >
                            <b-form-input
                            id="input-7"
                            v-model="form.email"
                            type="email"
                            placeholder="Email adresinizi girin."
                            required
                            ></b-form-input>
                    </b-form-group>    

                    <b-card
                        v-if="!form.fromSMS"
                        style="margin-bottom:16px; margin-top:25px;"
                    >
                        <b-form-group id="input-group-2" label-for="input-13">
                            <b-form-radio
                                id="input-13"
                                v-model="form.noImei"
                                :value="false"
                                required
                            >
                            IMEI / Seri Numaralı Cihaz:
                            </b-form-radio>
                        </b-form-group>

                        <b-form-group id="input-group-2" label-for="input-14">
                            <b-form-radio
                            id="input-14"
                            v-model="form.noImei"
                            :value="true"
                            required
                            >
                            IMEI / Seri Numarasız Cihaz:
                            </b-form-radio>
                        </b-form-group>

                        <b-form-group v-if="!form.noImei" id="input-group-2" label="Cihaz IMEI / Seri Numarası:" label-for="input-9">
                            <b-form-input
                            id="input-9"
                            v-model="form.imei"
                            placeholder="Cihazınızın IMEI / Seri numarasını girin."
                            required
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group 
                        v-if="!form.noImei"
                        id="input-group-2" label="Cihaz Markası:" label-for="input-8">
                            <b-form-input
                            id="input-8"
                            v-model="form.brand"
                            placeholder="Cihazınızın markasını girin."
                            required
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group 
                        v-if="form.noImei"
                        id="input-group-2" label="Ürün Kodu:" label-for="input-8">
                            <p>
                                Cihazınızın garanti belgesinde bulunan ürün kodunu girmelisiniz.
                            </p>

                            <b-form-input
                            id="input-8"
                            v-model="form.productCode"
                            placeholder="Cihazınızın ürün kodunu girin."
                            required
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-card>

                    <b-form-group v-if="!form.fromSMS" id="input-group-2" label="Cihaz Kilit Kodu:" label-for="input-10">
                        <b-form-input
                        id="input-10"
                        v-model="form.lockCode"
                        placeholder="Eğer varsa cihazınızın ekran kilit kodunu girin."
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Arıza Bilgisi:" label-for="input-11">
                        <b-form-textarea
                        id="input-11"
                        v-model="form.description"
                        placeholder="Cihazınızın arıza bilgisini belirtin.."
                        required
                        rows="3"
                        max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>

                    <b-form-group v-if="!form.fromSMS" id="input-group-2" label="Cihaz İle Birlikte Gönderilecek Aksesuarlar:" label-for="input-12">
                        <b-form-textarea
                        id="input-12"
                        v-model="form.accessories"
                        placeholder="Cihazınız ile birlikte göndereceğiniz aksesuarlarınızı belirtin."
                        rows="3"
                        max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </b-card>
                <b-card  class="mt-3" >
                    <b-button v-if="form.accepted == 'true'" type="reset" variant="">Temizle</b-button>               
                    <b-button v-if="form.accepted == 'true'" class="float-right ml-3" type="submit" variant="primary">Gönder</b-button>            
                    <b-button @click="$bvModal.hide('end-user-service-form')" class="float-right" variant="danger">İptal</b-button>               
                </b-card>

            </b-form>
        </b-overlay>
        
        <b-card title="Başvurunuz Alınmıştır" sub-title="" v-if="formResult.show">
            <b-card-text >
                <p>
                    Ürünü bize gönderirken; <b>Ürün Faturası</b>'nın' ve <b>Garanti Belgesi</b>'nin bir kopyasını eklemeyi unutmayınız. 
                </p>

                <p v-if="form.fromSMS">
                    Daha sonra ürününüzü <b>Yurtiçi Kargo</b> ile <b>aşağıdaki</b> gönderi kodunu kullanarak servisimize gönderebilirsiniz.
                </p>

                <p v-if="!form.fromSMS">
                    Ek olarak en altta gördüğünüz kayıt numarasını ürün üzerine not olarak yapıştırınız.
                </p>
                <p v-if="!form.fromSMS">
                    Arızalı ürününüzü aşağıdaki linkte bulunan yetkili servis noktamıza bırakmanızı, bulunduğunuz ilde yetkili servis noktamız mevcut değil ise  <b>Yurtiçi Kargo 146606309</b> anlaşma no ile alıcı ödemeli olarak servisimize gönderebilirsiniz.
                </p>
                <p v-if="!form.fromSMS" class="text-danger">
                    <b>Not: Yetkili servis noktalarımızın bulunduğu illerden Yurtiçi Kargo ile yapılan gönderilerin ödemesi firmamız tarafından karşılanmayıp göndericiye ait olacaktır.
                    <br/><br/>Yetkili servis noktaları için <a href="https://www.pencere.com/pencere_teknik_servis.html" target="_blank">tıklayınız.</a></b>
                </p>
              
                <p class="text-danger">Ürünü kargo ile gönderirken kargoda hasarlanmayacak şekilde ambalajlayıp gönderilmesi gerekmektedir. Ambalajının yetersiz olmasından dolayı ürünün hasarlı olarak tarafımıza ulaşması halinde sorumluluk firmamıza ait olmayıp, göndericiye aittir.</p> 

                <p>Ürününüzü giriş yaptığınız web sayfasından takip edebilirsiniz ya da 0 212 364 67 00 numaralı destek hattından ürününüzün durumunu sorgulayabilirsiniz.</p>
            
            </b-card-text>

            <h3 class="text-center m-5">{{formResult.documentId}}</h3>
            <div class="text-center">
                <b-button @click="$bvModal.hide('end-user-service-form')"  variant="danger">Kapat</b-button>               
            </div>
        </b-card>
    </div>
</template>

<script>
    import axios from 'axios';

export default {
        name: 'EndUserServiceForm',
        data() {
            return {
                uriAfterSales: process.env.VUE_APP_URI_ARENA_API_AFTERSALES,
                isLoading: false,
                form: this.createFormData(),
                noImeiBrands: [],
                cities: [
                    { text: 'Lütfen bir şehir seçin.', value: null }, 
                    { text: 'ADANA', value: { name: 'ADANA', region: '01' } },
                    { text: 'ADIYAMAN', value: { name: 'ADIYAMAN', region: '02' } },
                    { text: 'AFYONKARAHİSAR', value: { name: 'AFYONKARAHİSAR', region: '03' } },
                    { text: 'AĞRI', value: { name: 'AĞRI', region: '04' } },
                    { text: 'AKSARAY', value: { name: 'AKSARAY', region: '68' } },
                    { text: 'AMASYA', value: { name: 'AMASYA', region: '05' } },
                    { text: 'ANKARA', value: { name: 'ANKARA', region: '06' } },
                    { text: 'ANTALYA', value: { name: 'ANTALYA', region: '07' } },
                    { text: 'ARDAHAN', value: { name: 'ARDAHAN', region: '75' } },
                    { text: 'ARTVİN', value: { name: 'ARTVİN', region: '08' } },
                    { text: 'AYDIN', value: { name: 'AYDIN', region: '09' } },
                    { text: 'BALIKESİR', value: { name: 'BALIKESİR', region: '10' } },
                    { text: 'BARTIN', value: { name: 'BARTIN', region: '74' } },
                    { text: 'BATMAN', value: { name: 'BATMAN', region: '72' } },
                    { text: 'BAYBURT', value: { name: 'BAYBURT', region: '69' } },
                    { text: 'BİLECİK', value: { name: 'BİLECİK', region: '11' } },
                    { text: 'BİNGÖL', value: { name: 'BİNGÖL', region: '12' } },
                    { text: 'BİTLİS', value: { name: 'BİTLİS', region: '13' } },
                    { text: 'BOLU', value: { name: 'BOLU', region: '14' } },
                    { text: 'BURDUR', value: { name: 'BURDUR', region: '15' } },
                    { text: 'BURSA', value: { name: 'BURSA', region: '16' } },
                    { text: 'ÇANAKKALE', value: { name: 'ÇANAKKALE', region: '17' } },
                    { text: 'ÇANKIRI', value: { name: 'ÇANKIRI', region: '18' } },
                    { text: 'ÇORUM', value: { name: 'ÇORUM', region: '19' } },
                    { text: 'DENİZLİ', value: { name: 'DENİZLİ', region: '20' } },
                    { text: 'DİYARBAKIR', value: { name: 'DİYARBAKIR', region: '21' } },
                    { text: 'DÜZCE', value: { name: 'DÜZCE', region: '81' } },
                    { text: 'EDİRNE', value: { name: 'EDİRNE', region: '22' } },
                    { text: 'ELAZIĞ', value: { name: 'ELAZIĞ', region: '23' } },
                    { text: 'ERZİNCAN', value: { name: 'ERZİNCAN', region: '24' } },
                    { text: 'ERZURUM', value: { name: 'ERZURUM', region: '25' } },
                    { text: 'ESKİŞEHİR', value: { name: 'ESKİŞEHİR', region: '26' } },
                    { text: 'GAZİANTEP', value: { name: 'GAZİANTEP', region: '27' } },
                    { text: 'GİRESUN', value: { name: 'GİRESUN', region: '28' } },
                    { text: 'GÜMÜŞHANE', value: { name: 'GÜMÜŞHANE', region: '29' } },
                    { text: 'HAKKARİ', value: { name: 'HAKKARİ', region: '30' } },
                    { text: 'HATAY', value: { name: 'HATAY', region: '31' } },
                    { text: 'IĞDIR', value: { name: 'IĞDIR', region: '76' } },
                    { text: 'ISPARTA', value: { name: 'ISPARTA', region: '32' } },
                    { text: 'İSTANBUL', value: { name: 'İSTANBUL', region: '34' } },
                    { text: 'İZMİR', value: { name: 'İZMİR', region: '35' } },
                    { text: 'KAHRAMANMARAŞ', value: { name: 'KAHRAMANMARAŞ', region: '46' } },
                    { text: 'KARABÜK', value: { name: 'KARABÜK', region: '78' } },
                    { text: 'KARAMAN', value: { name: 'KARAMAN', region: '70' } },
                    { text: 'KARS', value: { name: 'KARS', region: '36' } },
                    { text: 'KASTAMONU', value: { name: 'KASTAMONU', region: '37' } },
                    { text: 'KAYSERİ', value: { name: 'KAYSERİ', region: '38' } },
                    { text: 'KIRIKKALE', value: { name: 'KIRIKKALE', region: '71' } },
                    { text: 'KIRKLARELİ', value: { name: 'KIRKLARELİ', region: '39' } },
                    { text: 'KIRŞEHİR', value: { name: 'KIRŞEHİR', region: '40' } },
                    { text: 'KİLİS', value: { name: 'KİLİS', region: '79' } },
                    { text: 'KOCAELİ (İZMİT)', value: { name: 'KOCAELİ (İZMİT)', region: '41' } },
                    { text: 'KONYA', value: { name: 'KONYA', region: '42' } },
                    { text: 'KÜTAHYA', value: { name: 'KÜTAHYA', region: '43' } },
                    { text: 'MALATYA', value: { name: 'MALATYA', region: '44' } },
                    { text: 'MANİSA', value: { name: 'MANİSA', region: '45' } },
                    { text: 'MARDİN', value: { name: 'MARDİN', region: '47' } },
                    { text: 'MERSİN', value: { name: 'MERSİN', region: '33' } },
                    { text: 'MUĞLA', value: { name: 'MUĞLA', region: '48' } },
                    { text: 'MUŞ', value: { name: 'MUŞ', region: '49' } },
                    { text: 'NEVŞEHİR', value: { name: 'NEVŞEHİR', region: '50' } },
                    { text: 'NİĞDE', value: { name: 'NİĞDE', region: '51' } },
                    { text: 'ORDU', value: { name: 'ORDU', region: '52' } },
                    { text: 'OSMANİYE', value: { name: 'OSMANİYE', region: '80' } },
                    { text: 'RİZE', value: { name: 'RİZE', region: '53' } },
                    { text: 'SAKARYA (ADAPAZARI)', value: { name: 'SAKARYA (ADAPAZARI)', region: '54' } },
                    { text: 'SAMSUN', value: { name: 'SAMSUN', region: '55' } },
                    { text: 'SİİRT', value: { name: 'SİİRT', region: '56' } },
                    { text: 'SİNOP', value: { name: 'SİNOP', region: '57' } },
                    { text: 'SİVAS', value: { name: 'SİVAS', region: '58' } },
                    { text: 'ŞANLIURFA', value: { name: 'ŞANLIURFA', region: '63' } },
                    { text: 'ŞIRNAK', value: { name: 'ŞIRNAK', region: '73' } },
                    { text: 'TEKİRDAĞ', value: { name: 'TEKİRDAĞ', region: '59' } },
                    { text: 'TOKAT', value: { name: 'TOKAT', region: '60' } },
                    { text: 'TRABZON', value: { name: 'TRABZON', region: '61' } },
                    { text: 'TUNCELİ', value: { name: 'TUNCELİ', region: '62' } },
                    { text: 'UŞAK', value: { name: 'UŞAK', region: '64' } },
                    { text: 'VAN', value: { name: 'VAN', region: '65' } },
                    { text: 'YALOVA', value: { name: 'YALOVA', region: '77' } },
                    { text: 'YOZGAT', value: { name: 'YOZGAT', region: '66' } },
                    { text: 'ZONGULDAK', value: { name: 'ZONGULDAK', region: '67' } },
                ],
                formResult: {
                    show: false,
                    documentId:null
                }
            }
        },
        methods: {
            async onSubmit(event) {
                event.preventDefault();
                this.isLoading = true;
                await this.$recaptchaLoaded();
                const token = await this.$recaptcha('ServiceFormForm');
                this.form.recaptchaToken = token;
                axios.post(`${this.uriAfterSales}/ServiceForm`, this.form)
                .then(response =>{
                    if(response.data.success) {
                        this.formResult.documentId = response.data.data.documentId;
                        this.form.show = false;
                        this.formResult.show = true;
                    } else {
                        if(this.form.noImei)
                        {
                            alert("Kayıt oluşturulamadı!\r\n\r\nLütfen cihazınızın garanti belgesinde bulunan \"Ürün Kodu\" bilgisini kontrol edip tekrar deneyin.\r\n\r\nSorun devam ederse teknik servisimiz veya müşteri temsilciniz ile görüşebilirsiniz.");
                        }   
                        else
                        {

                            alert("Kayıt oluşturulamadı!\r\n\r\n" + response.data.message);
                        }         
                    }
                    this.isLoading = false;  
                }).catch(error => {
                    console.log(error);
                    alert("Bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
                    this.isLoading = false;
                });
                
            },
            onReset(event) {
                event.preventDefault();
                this.form = this.createFormData();
            },
            createFormData() {        

                const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
                });

                var from_sms = params.sirketSMS ? true : false;
                var fromSMS = from_sms ? {
                    companyCode: params.sirketSMS
                } : null;

                return {
                    fromSMS : fromSMS,
                    show : true,
                    nameSurname : '',
                    address1 :'',
                    address2 :'',
                    address3 :'',
                    TCKN : '',
                    city : null,
                    telephone : '',
                    email: '',
                    brand: '',
                    noImei: false,
                    productCode: '',
                    imei: '',
                    lockCode: '',
                    description: '',
                    accessories: '',
                    accepted: 'false',
                    recaptchaToken:null
                };
            }
        },
        async mounted() {
            // this.noImeiBrands  =  await axios.get(`${this.uriAfterSales}/ServiceForm/NoImeieBrands`)
            // .then(response => {
            //     if(response.data.success) {
            //         return response.data.data;
            //     } else {
            //         alert(response.data.message);               
            //     }
            //     this.isLoading = false;  
            //     return [];
            // }).catch(() => {
            //     alert("Bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
            //     this.isLoading = false;
            //     return [];
            // });
        }
    }
</script>

<style scoped>

</style>